/**
 * Contoh settings per provider. Konsol tidak mengarang kontrak: nilai di sini
 * mengikuti default server (`snap.DefaultSettingsVA` dan
 * `snap.DefaultVAMerchantSettings`), dan hanya dipakai sebagai titik awal yang
 * bisa disunting operator.
 *
 * Alasannya ada di sini, bukan di tiap formulir: kredensial dan merchant VA
 * memakai kunci yang berbeda dari QRIS, sedangkan server menolak kunci yang
 * tidak dikenal dengan kode 422. Menempelkan contoh QRIS ke VA adalah kesalahan
 * yang mudah terjadi, jadi formulir mengisi contoh sesuai kanal.
 */

/** Nama provider kanal Virtual Account On Us bank bjb. */
export const providerBJBVA = 'bjb-va'

/** Nama provider kanal QRIS MPM bank bjb. */
export const providerBJBQRIS = 'bjb-qris'

/** Provider sandbox lokal tanpa bank. */
export const providerSandbox = 'sandbox'

/**
 * Contoh settings kredensial untuk sebuah provider. String kosong berarti
 * provider itu tidak memakai settings (sandbox) atau contohnya tidak perlu
 * ditampilkan (QRIS, karena nilai bawaannya sudah benar tanpa diisi).
 */
export function credentialSettingsTemplate(provider: string): string {
  if (provider !== providerBJBVA) {
    return ''
  }
  return JSON.stringify(
    {
      paths: {
        create_va: '/v1.0/transfer-va/create-va',
        inquiry_va: '/v1.0/transfer-va/inquiry-va',
        update_va: '/v1.0/transfer-va/update-va',
        status: '/v1.0/transfer-va/status',
      },
      inbound: {
        notify_hmac_encoding: 'base64',
      },
    },
    null,
    2,
  )
}

/** Petunjuk kunci settings yang berlaku untuk sebuah provider kredensial. */
export function credentialSettingsHint(provider: string): string {
  if (provider === providerBJBVA) {
    return 'Kunci VA: paths.create_va, paths.inquiry_va, paths.update_va, paths.status, dan inbound.notify_hmac_encoding (hex atau base64). Opsional: inbound.token_rsa_encoding bila tanda tangan token dari bank bukan hex. Jangan memakai paths.generate atau paths.query milik QRIS.'
  }
  if (provider === providerBJBQRIS) {
    return 'Kunci QRIS: paths.generate dan paths.query. Jangan memakai kunci path VA.'
  }
  return 'Provider sandbox tidak memakai settings.'
}

/**
 * Contoh settings merchant untuk sebuah provider. Merchant VA memakai lima
 * kunci yang divalidasi `snap.ParseVAMerchantSettings`; partner_service_id
 * sengaja dikosongkan karena bank yang menerbitkannya.
 */
export function merchantSettingsTemplate(provider: string): string {
  if (provider !== providerBJBVA) {
    return ''
  }
  return JSON.stringify(
    {
      partner_service_id: '',
      customer_no: '000000000000000',
      product_code: '01',
      billing_type: 'f',
      va_type: 'a',
    },
    null,
    2,
  )
}

/** Petunjuk kunci settings yang berlaku untuk sebuah provider merchant. */
export function merchantSettingsHint(provider: string): string {
  if (provider === providerBJBVA) {
    return 'Kunci VA: partner_service_id (8 digit dengan padding spasi kiri), customer_no, product_code, billing_type (f atau o), dan va_type (a atau m).'
  }
  if (provider === providerBJBQRIS) {
    return 'Kunci QRIS: payment_id, channel_id, dan transaction_purpose.'
  }
  if (provider === providerSandbox) {
    return 'Merchant sandbox tidak memakai settings.'
  }
  return 'Pilih kredensial lebih dulu; kunci settings mengikuti provider kredensial itu.'
}
